import { nonPrimary, protocolPaused } from 'shared/constants/errors'

export type BorrowLockCode =
  | 'fraud'
  | 'scoreChanged'
  | 'badScore'
  | 'nonPrimary'

export const BORROW_LOCK_CODES_MESSAGES: Record<BorrowLockCode, string> = {
  fraud:
    'You cannot borrow from RociFi at the moment. Please improve your score and come back',
  scoreChanged:
    'You cannot borrow from RociFi at the moment. Please repay your loan first',
  badScore:
    'Since you missed the due date of your loan, you can’t borrow on RociFi anymore. Reach out to us on Discord if you want to borrow on RociFi again',
  nonPrimary,
}

export type CollateralLockCode = 'nonPrimary' | 'protocolPaused'

export const COLLATERAL_LOCK_CODES_MESSAGES: Record<
  CollateralLockCode,
  string
> = {
  protocolPaused,
  nonPrimary,
}
